import { render, staticRenderFns } from "./number-service-config-field.component.vue?vue&type=template&id=2461cfe0&scoped=true"
import script from "./number-service-config-field.component.vue?vue&type=script&lang=ts"
export * from "./number-service-config-field.component.vue?vue&type=script&lang=ts"
import style0 from "./number-service-config-field.component.vue?vue&type=style&index=0&id=2461cfe0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2461cfe0",
  null
  
)

export default component.exports